class BundleLayoutSelectorButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange.bind(this));
  }

  #onChange(event) {
    if (event.target.name !== 'bundles-layout') {
      return;
    }

    const layout = event.target.value;

    fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          bundles_collection_layout: layout
        }
      })
    });

    document.querySelectorAll('.bundles-kits__list').forEach((list) => {
      list.classList.remove('bundles-kits__list--detailed', 'bundles-kits__list--grid');
      list.classList.add(`bundles-kits__list--${layout}`);
    });

    document.documentElement.setAttribute('data-bundles-layout', layout);

    document.querySelectorAll('input[name="bundles-layout"]').forEach((input) => {
      input.checked = input.value === layout;
    });
  }
}

if (!window.customElements.get('bundle-layout-selector-button')) {
  window.customElements.define('bundle-layout-selector-button', BundleLayoutSelectorButton);
}
